import { Injectable } from "@angular/core";
import { Api } from "../api/api";
import { Observable } from "rxjs/Observable";
import { Appointment, AppointmentState } from "../../models/appointment";
import { ChatRoom } from "../../models/chat-room";
import { AlertController } from "ionic-angular";

@Injectable()
export class AppointmentProvider {
  constructor(public api: Api, private alertCtrl: AlertController) {}

  create(appointment: Appointment): Observable<number> {
    return this.api.post("me/appointments", appointment).map((data) => data.id);
  }

  update(id: number, state: AppointmentState): Observable<any> {
    return this.api.put(`me/appointments/${id}`, { state: state });
  }

  load(page: number): Observable<ChatRoom[]> {
    return this.api
      .get("me/appointments", false, { page: page })
      .map((chatRooms) => chatRooms.map((chatRoom) => new ChatRoom(chatRoom)));
  }

  loadAppointmentList(): Observable<Appointment[]> {
    return this.api
      .get("me/appointments/for_check_duplicate_dates", false)
      .map((appointmentList) =>
        appointmentList.map((appointment) => new Appointment(appointment))
      );
  }

  loadReminding(): Observable<ChatRoom[]> {
    return this.api
      .get("me/appointments/remindings")
      .map((chatRooms) => chatRooms.map((chatRoom) => new ChatRoom(chatRoom)));
  }

  showDubbleBookedBoardAlert(callback: Function): void {
    const alert = this.alertCtrl.create({
      title: "選択された日付で<br />募集が作成されています",
      subTitle: "予定の重複にお気をつけください",
      buttons: [
        {
          text: "OK",
        },
      ],
    });
    alert.present();
    alert.onDidDismiss(() => {
      callback();
      return;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/appointment/appointment.ts